var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTraingle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.75879,
    cy: 9,
    r: 9,
    fill: "#EA3829"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75821 14.148C9.48143 14.1577 9.21176 14.0595 9.00628 13.874C8.60989 13.4364 8.60989 12.7701 9.00628 12.3325C9.2095 12.1425 9.48008 12.0412 9.75825 12.0508C10.0419 12.0394 10.3173 12.1471 10.5179 12.3477C10.7124 12.549 10.8169 12.8204 10.8075 13.0999C10.8224 13.3815 10.724 13.6574 10.5343 13.8663C10.326 14.0637 10.0448 14.1658 9.75821 14.148Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75889 10.1C9.26201 10.1 8.85889 9.69687 8.85889 9.2V4.4C8.85889 3.90313 9.26201 3.5 9.75889 3.5C10.2558 3.5 10.6589 3.90313 10.6589 4.4V9.2C10.6589 9.69687 10.2558 10.1 9.75889 10.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTraingle);
export default __webpack_public_path__ + "static/media/alert_traingle.76b8b57c54a5b28914f2dfc67a43ae2a.svg";
export { ForwardRef as ReactComponent };